import React, { FC } from "react";
import { CommandLineIcon, UsersIcon } from "@heroicons/react/24/solid";
import { testimonials } from "../data";

interface Testimonial {
  quote: string;
  image: string;
  name: string;
  company: string;
}

const Testimonials: FC = () => {
  return (
    <section id="testimonials">
      <div className="container px-5 py-10 mx-auto text-center">
        <UsersIcon className="w-10 inline-block mb-4" />
        <h1 className="sm:text-4xl text-3xl font-medium title-font text-white mb-12">
          Client Testimonials
        </h1>

        <div className="flex flex-wrap m-4">
          {testimonials.map((testimonial: Testimonial) => (
            <div className="p-4 w-full">
              <div className="h-full bg-gray-800 bg-opacity-40 p-8 rounded">
                <CommandLineIcon className="block w-8 text-gray-500 mb-4" />

                {/* <p className="leading-relaxed mb-6">{testimonial.quote}</p> */}
                
                <div className="inline-flex items-center">
                  <img
                    alt="testimonial"
                    src={testimonial.image}
                    className="flex-shrink-0 object-cover object-center"
                  />
                  
                  {/* <span className="flex-grow flex flex-col pl-4">
                    <span className="title-font font-medium text-white">
                      {testimonial.name}
                    </span>
                    <span className="text-gray-500 text-sm uppercase">
                      {testimonial.company}
                    </span>
                  </span> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;